module.exports = __webpack_public_path__ + "static/media/joshua-earlez.a9fea6a7.jpg";